import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { RolePermission } from '../../roles-permissions.types';

@Component({
  selector: 'app-settings-roles-list',
  templateUrl: './roles-list.component.html',
  styleUrls: ['./roles-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsRolesListComponent {
  @Input() roles: RolePermission[];
  @Input() selectedRole: RolePermission;
  @Output() roleSelected = new EventEmitter<RolePermission>();

  onRoleSelected(selectedRole: RolePermission): void {
    this.roleSelected.emit(selectedRole);
  }
}
